module.exports = __webpack_public_path__ + "static/media/img-not-found-300x450.9d33d83f.png";